export const PATHS = {
  seo: 'tasks',
  'paid-media': 'campaigns',
  content: 'guidelines',
};

export const TYPE_STYLES = {
  NEW_COMMENT: {
    background: 'rgba(85, 110, 230, 0.10)',
    textColor: 'var(--Primary-accent, #3B5BFC)',
    outline: '1px var(--Primary, #556EE6) solid',
  },
  USER_ASSIGNED: {
    background: 'rgba(114, 46, 209, 0.10)',
    textColor: '#722ED1',
    outline: '1px #722ED1 solid',
  },
  ITEM_CREATED: {
    background: 'rgba(52, 195, 143, 0.10)',
    textColor: 'var(--Success-accent, #25855A)',
    outline: '1px var(--Success, #34C38F) solid',
  },
  NEW_ACTIONABLE: {
    background: 'rgba(241, 180, 76, 0.10)',
    textColor: 'var(--Warning-accent, #B7791F)',
    outline: '1px var(--Warning, #F1B44C) solid',
  },
  NEW_IMPLEMENTATION: {
    background: 'rgba(250, 84, 28, 0.10)',
    textColor: '#FA541C',
    outline: '1px #FA541C solid',
  },
};

export const TYPE_LABELS = {
  NEW_COMMENT: 'New comment',
  USER_ASSIGNED: 'Responsible',
  ITEM_CREATED: 'New task',
  NEW_ACTIONABLE: 'New actionable',
  NEW_IMPLEMENTATION: 'New implementation',
};
